import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type ReactRendererService from 'garaje/services/react-renderer';
import type { Root } from 'react-dom/client';

export default class LocationOverviewPoliciesShowController extends Controller {
  @service declare reactRenderer: ReactRendererService;

  declare model: string;

  private root?: Root;

  @action
  async injectComponent(): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { PolicyDetails } = await import('reactRichComponents/visitors/PolicyDetails');

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.root = await this.reactRenderer.render(PolicyDetails, 'react__visitors__settings__policies__show', {
      policyId: this.model,
    });
  }

  @action
  destroyComponent(): void {
    if (this.root) {
      this.reactRenderer.unmount(this.root);
      this.root = undefined;
    }
  }
}
